import React, { ReactNode } from 'react';
import { X } from 'lucide-react';
import { Button } from './button';

interface ModalProps {
  isOpen: boolean;
  onClose?: () => void;
  title: string;
  children: ReactNode;
  footer?: ReactNode;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  title,
  children,
  footer,
  size = 'md'
}) => {
  if (!isOpen) return null;

  const sizeClasses = {
    sm: 'max-w-sm',
    md: 'max-w-md',
    lg: 'max-w-lg',
    xl: 'max-w-xl'
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4 backdrop-blur-sm">
      <div className={`bg-white dark:bg-gray-900 rounded-xl shadow-xl ${sizeClasses[size]} w-full max-h-[90vh] overflow-auto border border-gray-100 dark:border-gray-800`}>
        <div className="p-6">
          <div className="flex justify-center items-center mb-4">
            <h3 className="text-xl text-center font-semibold text-gray-900 dark:text-white">{title}</h3>
            <button 
              type="button"
              onClick={onClose}
              className="p-1 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
            >
              {/*<X size={20} className="text-gray-500 dark:text-gray-400" />*/}
            </button>
          </div>
          
          <div className="mb-6">
            {children}
          </div>
          
          {footer && (
            <div className="flex justify-between space-x-2">
              {footer}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Modal;
